export interface ITripsOverviewColumn {
  key: string;
  default: boolean;
  hidden: boolean;
}

export const IS_DAY_TIME = 'IS_DAY_TIME';
export const DAY_TIME_ONLY_DAY = 'onlyday';
export const DAY_TIME_ONLY_NIGHT = 'onlynight';
export const DAY_TIME_WORKWEEK = 'workweek';
export const DAY_TIME_WEEKEND = 'weekend';
export const INFO_FILTER = 'infoFilter';
export const WP_OFF = 'wpOff';
export const WP_WITHOUT = 'wpWithout';
export const WP_ACTIVE = 'wpActive';
export const EVENT_OFF = 'eventOff';
export const EVENT_WITHOUT = 'eventWithout';
export const EVENT_ACTIVE = 'eventActive';
export const ALARM_OFF = 'alarmOff';
export const ALARM_WITHOUT = 'alarmWithout';
export const ALARM_ACTIVE = 'alarmActive';
export const PURPOSE_OFF = 'purposeOff';
export const PURPOSE_WITHOUT = 'purposeWithout';
export const PURPOSE_ACTIVE = 'purposeActive';
export const COMMENT_OFF = 'commentOff';
export const COMMENT_WITHOUT = 'commentWithout';
export const COMMENT_ACTIVE = 'commentActive';
export const BLUECOIN_OFF = 'bluecoinOff';
export const BLUECOIN_WITHOUT = 'bluecoinWithout';
export const BLUECOIN_ACTIVE = 'bluecoinActive';
export const ANNOUNCEMENT_WAYPOINT_KEY = 'announcementWaypoint';
export const ANNOUNCEMENT_EVENT_KEY = 'announcementEvent';
export const ANNOUNCEMENT_ALARM_KEY = 'announcementAlarm';
export const RIDEBOOK_PURPOSE_KEY = 'ridebookPurpose';
export const ANNOUNCEMENT_BLUECOIN_KEY = 'announcementBluecoin';
export const COMMNENT_KEY = 'commnent';
export const DAYS_KEY = 'days';
export const TIME_KEY = 'time';

export const POSITION_WAYPOINTS = 'waypoints';
export const POSITION_EVENTS = 'events';
export const POSITION_ALARMS = 'alarms';

export const DEFAULT_VALUES_DAY_TIME_FORM = {
  days: ['0', '1', '2', '3', '4', '5', '6'],
  timeFrom: new Date(new Date().setHours(0, 0, 0, 0)),
  timeTo: new Date(new Date().setHours(23, 59, 59, 0)),
  closedInterval: false,
};
export const DEFAULT_INFO_FILTER_RADIO_BTN_VALUES = {
  waypoint: [{ id: WP_OFF }, { id: WP_WITHOUT }, { id: WP_ACTIVE }],
  event: [{ id: EVENT_OFF }, { id: EVENT_WITHOUT }, { id: EVENT_ACTIVE }],
  alarm: [{ id: ALARM_OFF }, { id: ALARM_WITHOUT }, { id: ALARM_ACTIVE }],
  purpose: [{ id: PURPOSE_OFF }, { id: PURPOSE_WITHOUT }, { id: PURPOSE_ACTIVE }],
  comment: [{ id: COMMENT_OFF }, { id: COMMENT_WITHOUT }, { id: COMMENT_ACTIVE }],
  bluecoin: [{ id: BLUECOIN_OFF }, { id: BLUECOIN_WITHOUT }, { id: BLUECOIN_ACTIVE }],
};

export const DEFAULT_INFO_FILTER_FORM_VALUES = {
  announcementAlarm: [],
  announcementEvent: [],
  announcementWaypoint: [],
  announcementBluecoin: [],
  ridebookPurpose: {},
  comment: false,
  waypointChoice: 'wpOff',
  alarmChoice: 'alarmOff',
  eventChoice: 'eventOff',
  purposeChoice: 'purposeOff',
  commentChoice: 'commentOff',
  bluecoinChoice: 'bluecoinOff',
  alarmChipName: null,
  eventChipName: null,
  waypointChipName: null,
  purposeChipName: null,
  commentChipName: null,
  bluecoinChipName: null,
  customerId: [],
};

export interface ITripsOverviewData {
  count: number | null;
  availableCount: number;
  records: ITripsOverViewRecord[];
  summaries: ITripsOverViewSummary[];
  status: 200;
}

export interface ITripsOverviewSettings {
  settings: {
    id: number;
    key: string;
    userId: number;
    value: ITableSettingsData;
  };
  status: 200;
}

export interface ITripsOverviewChipOption {
  value: number;
  item: string;
  deleted?: boolean;
  color?: string;
  customerId?: number;
  customerLabel?: string;
  type?: 'customer' | 'private';
  eventType?: string;
  shortChipName?: string;
  popup?: string;
}

export const DEFAULT_ORDER_COLUMNS: { key: string; hidden: boolean }[] = [
  { key: 'locked', hidden: false },
  { key: 'timestamp', hidden: false },
  { key: 'vehicle', hidden: false },
  { key: 'isPrivate', hidden: false },
  { key: 'address', hidden: false },
  { key: 'info', hidden: false },
  { key: 'distance', hidden: false },
  { key: 'driver', hidden: false },
  { key: 'duration', hidden: false },
  { key: 'ecoScore', hidden: false },
  { key: 'fuelConsumption', hidden: false },
  { key: 'avgConsumption', hidden: false },
  { key: 'parking', hidden: false },
  { key: 'customer', hidden: true },
  { key: 'maxSpeed', hidden: true },
  { key: 'avgSpeed', hidden: true },
  { key: 'mileage', hidden: true },
  { key: 'increase', hidden: true },
  { key: 'decline', hidden: true },
  { key: 'actions', hidden: false },
];

export interface ITableSummariesFilter {
  filter: IFilterTripsOverview;
  sort: {
    [key: string]: string;
  };
  dateFrom: string | undefined;
  dateTo: string | undefined;
}

export interface IFilterTable {
  type: string;
  value: any;
  values: {
    value: string | number | boolean | { min: number; max: number } | string[];
    item: string;
    label?: string;
  }[];
  required: boolean;
  selectedValue?: { min: string; max: string };
  minDate?: string;
  maxDate?: string;
  multiple?: boolean;
  filtered?: boolean;
  hidden?: boolean;
  subType?: string;
  minValue?: number;
  maxValue?: number;
}

export interface IEndpoitData {
  offset: number;
  filter: {
    [key: string]: any;
  };
  sort: { [key: string]: string };
}

export interface ITableSettingsData {
  columns: { name: string; hidden: boolean }[];
  periodicSummaries: {
    displayData: string[] | null;
    periodicity: string | null;
  };
  overviewSummary: boolean;
  showSummaries: boolean;
  sort: {
    column: string;
    direction: string;
  };
}

export interface ITableSummaryData {
  periodicSummaries: {
    displayData: string[] | null;
    periodicity: string | null;
  };
  overviewSummary: boolean;
}

export interface IEcoDriveViolation {
  duration: string;
  endTs: string;
  maxValue: string;
  startTs: string;
  type: string;
}

export interface IEcoDriveGraphData {
  distance: string | number;
  ecoDrive: number;
  violations: IEcoDriveViolation[];
  x: string;
}

export interface IEcodriveData {
  driver: {
    id: number | null;
    name: string;
  };
  ride: {
    distance: number;
    endAddress: string;
    endTs: string;
    isPrivate: boolean;
    startAddress: string;
    startTs: string;
  };
  score: {
    avg7Days: number | null;
    avg30Days: number | null;
    avgToday: number | null;
    current: number | null;
  };
  graph: {
    columnAliases: string[];
    customerId: number;
    data: IEcoDriveGraphData[];
    dateFrom: string;
    dateTo: string;
    vehicleId: number[];
  };
  vehicle: {
    icon: string;
    id: number;
    name: string;
  };
  status: 200;
}

export interface ITripsOverviewAdvancedFilterForRequest {
  days: string[];
  timeFrom: number;
  timeTo: number;
  closedInterval: boolean;
}

export interface ITripsOverViewSummariesCell {
  name: string;
  value: {
    public: string | number;
    private: string | number;
    total?: string | number;
    anonymized?: string | number | null;
  };
}

export interface ITripsOverViewSummary {
  title: string;
  from: string;
  to: string;
  type: string;
  rideCount: number | null;
  cells: ITripsOverViewSummariesCell[];
  anonymized: boolean;
}

export interface IInfoRecord {
  id: number | null;
  title: string;
  group: string;
  type: string;
  entityId: number | null;
  activatedAt: string | null;
  duration: string | null;
}

export interface IInfoRideTag {
  id: number;
  customerId: number;
  color: string;
  group: string;
  active: boolean;
  createdAt: string;
  createdBy: number;
  modifiedAt: string | null;
  modifiedBy: number | null;
  deletedAt: string | null;
  deletedBy: number | null;
  rideId: string | null;
  parkingId: number | null;
  name: string | null;
  note?: string;
}

export interface IInfoParkingTag {
  id: number;
  customerId: number;
  note: string;
  color: string;
  group: string;
  active: boolean;
  createdAt: string;
  createdBy: number;
  modifiedAt: string | null;
  modifiedBy: number | null;
  deletedAt: string | null;
  deletedBy: number | null;
  parkingId: number | null;
  name?: string;
}

export interface ITripsOverviewInfo {
  summary: {
    waypoint: number | string;
    event: number | string;
    alarm: number | string;
    tag: number | string;
    comment: number | string;
  };
  records: IInfoRecord[];
  rideTags: IInfoRideTag[];
  parkingTags: IInfoParkingTag[];
  rideComment: string | null;
  parkingComment: string | null;
  recordsCount: number;
}

export interface ITripOverviewParking {
  id: string;
  duration: string | null;
  timestamp: { start: string; end: string | null };
  address: {
    start: string;
    end: string | null;
    startLink: string | null;
    endLink: string | null;
  };
  summary: {
    alarm: number | string;
    event: number | string;
    waypoint: number | string;
    tag: number | string;
    comment: number | string;
  };
}

export interface ITripsOverViewRecord {
  locked: string;
  address: { start: string; end: string; startLink?: string; endLink?: string };
  info: ITripsOverviewInfo;
  avgConsumption: string;
  avgSpeed: string;
  customer: { name: string; label: string; id: number };
  decline: string;
  distance: string;
  driver: { name: string | null; id: number | null };
  duration: string | null;
  ecoScore: string;
  fuelConsumption: string;
  increase: string;
  isPrivate: boolean;
  source?: string;
  maxSpeed: string;
  mileage: string;
  parking: ITripOverviewParking | null;
  timestamp: { start: string; end: string };
  vehicle: { name: string; licenceNumber: string; id: number };
  id: string;
  positionCount: string;
  open?: boolean;
  co2EmissionsCan: {
    avgCan: number | null;
    avgTheo: number | null;
    avgVehicle: number | null;
    valueCan: number | null;
    valueTheo: number | null;
  };
}

export interface IFilterTripsOverview {
  [key: string]:
    | string
    | number
    | boolean
    | number[]
    | { min?: Date; max?: Date }
    | Date
    | string[];
}

export interface ITripsOverviewTableData {
  count: number | null;
  availableCount: number;
  summaries: ITripsOverViewSummary[];
}

export interface ITripsOverviewAdvancedFilters {
  days: string[];
  timeFrom: Date;
  timeTo: Date;
  closedInterval: boolean;
  announcementAlarm: string[];
  announcementEvent: string[];
  announcementWaypoint: string[];
  announcementBluecoin: string[];
  ridebookPurpose: { [key: string]: string[] };
  comment: boolean;
  waypointChoice: string;
  eventChoice: string;
  alarmChoice: string;
  purposeChoice: string;
  commentChoice: string;
  bluecoinChoice: string;
  alarmChipName: string | null;
  eventChipName: string | null;
  waypointChipName: string | null;
  purposeChipName: string | null;
  commentChipName: string | null;
  bluecoinChipName: string | null;
  customerId: number[];
}

export interface IIsActiveAdvanceFilter {
  days: boolean;
  time: boolean;
  announcementWaypoint: boolean;
  announcementEvent: boolean;
  announcementBluecoin: boolean;
  announcementAlarm: boolean;
  ridebookPurpose: boolean;
  comment: boolean;
}

export interface IContentData {
  name: string;
  value: string | number;
}

export interface ITagItem {
  id: string;
  name: string;
  color: string;
  item: string;
  value: string;
}

export interface IParkingSummary {
  alarm: number;
  event: number;
  waypoint: number;
  tag: number;
  comment: number;
}

export interface ICheckedRecord {
  id: string;
  checked: boolean;
  startTimestamp: string;
  vehicleId: number;
  customerId: number;
  driverId: number | null;
  isPrivate: boolean;
  locked: string;
  parkingId?: string;
}

export interface IFilterChipsValues {
  value: string | number | boolean | { min: number; max: number } | (string | number)[];
  item: string | number;
  title: string;
  type: string;
  max?: string;
  min?: string;
  unit?: string;
  noteFrom?: string;
  noteTo?: string;
  suffixInput?: string;
}

export interface IActionFilter {
  id: string;
  isOpen: boolean;
  isActionChipsOpen?: boolean;
  title?: string | null;
  values: IFilterChipsValues | null;
  isFilterActive?: boolean;
  filterType?: string | null;
  suffixInput?: string;
  data?: IFilterTable | null;
}

export interface ICheckedTableItems {
  mainCheckbox: boolean;
  intervals: { min: string; max: string }[];
  intervalsBlacklist: { min: string; max: string }[];
  rideIdBlacklist: { [customerId: string]: string[] };
  rideIds: { [customerId: string]: string[] };
  customerId: string | null;
  counts: { [intervalId: string]: string };
}

export interface ITableSettingsResponse {
  id: number;
  key: string;
  userId: number;
  value: {
    showSummaries: boolean;
    columns: {
      name: string;
      hidden: boolean;
    }[];
    overviewSummary: boolean;
    periodicSummaries: {
      displayData: string[];
      periodicity: string;
    };
    sort: { column: string; direction: string };
  };
}

export interface TripOverviewState {
  days: string[];
  timeFrom: Date;
  timeTo: Date;
  closedInterval: boolean;
  announcementAlarm: any[];
  announcementEvent: any[];
  announcementWaypoint: any[];
  announcementBluecoin: any[];
  ridebookPurpose: Record<string, any>;
  comment: boolean;
  waypointChoice: string;
  alarmChoice: string;
  eventChoice: string;
  purposeChoice: string;
  commentChoice: string;
  bluecoinChoice: string;
  alarmChipName: string | null;
  eventChipName: string | null;
  waypointChipName: string | null;
  purposeChipName: string | null;
  commentChipName: string | null;
  bluecoinChipName: string | null;
  customerId: any[];
}

export interface IAddComment {
  comment: string;
}

export interface ILastElementOfTable {
  (node: HTMLDivElement | null): void;
}

export interface ITableSettings {
  show: string;
  interval: string;
  all: boolean;
  public: boolean;
  private: boolean;
}

export interface IGetVehiclesData {
  deleted: boolean;
  item: string;
  label: string;
  value: string;
}
export interface IRidebookDownloadData {
  canConsumption: boolean;
  dateFrom: string;
  dateTo: string;
  ecoScore: boolean;
  format: string;
  refuelingConsumption: boolean;
  reportId: string;
  rideTag: boolean;
  showEmpty: boolean;
  vat: boolean;
  vehicleIds: string[];
}
